export const routes = Object.freeze({
    path: {
        guestInfo: "/requestinfo/guest_information",
        guestConfirmation: "/requestinfo/guest_confirmation",
    },
    ajax: {
        submitInquiry: "/self-serve/request-info/submit/",
    }
});